import loadable from '@loadable/component';

export const SearchJobsRefinementsLoadable = loadable(
  () => import('./SearchJobsRefinements'),
  { resolveComponent: (module) => module.SearchJobsRefinements },
);
